<template>
  <main-layout>
    <b-paginated-table
        :items="items"
        :fields="fields"
        :busy="isBusy"
        :sort-by.sync="options.sortBy"
        :sort-desc.sync="options.sortDesc"
        :filter="options.filter"
        :filter-function="filterFunction"
        @filtered="onFiltered"
    >
      <template v-slot:top-row>
        <td colspan="100%">
          <b-button block variant="outline-primary" @click="createExercice">
            <b-icon-plus class="mr-2"/>
            <span>Nouvel Exercice</span>
          </b-button>
        </td>
      </template>
      <template v-slot:cell(Actions)="{item:{id}}">
        <b-button variant="primary" @click="editExercice(id)" size="sm" class="mr-1">Editer</b-button>
        <b-button variant="outline-danger" size="sm">Supprimer</b-button>
      </template>
    </b-paginated-table>
  </main-layout>
</template>

<script>
import {Exercice} from "@/js/caller";
import {History} from "@/js/history";
import BPaginatedTable from "@/components/BPaginatedTable";
import {DataFormat} from "@/js/utils";

export default {
  name      : "ExerciceList",
  components: {BPaginatedTable},
  data() {
    const niveaux = DataFormat.Exercices.Niveau
    const types = DataFormat.Exercices.Type
    return {
      isBusy     : true,
      currentPage: 1,
      rows       : 0,
      fields     : [
        {key: "niveau", label: "Niveau", filterable: niveaux},
        {key: "type", label: "Type", filterable: types},
        {key: "titre", label: "Titre", filterable: true, sortable: true},
        {key: "lecon", label: "Leçon"},
        'Actions'
      ],
      items      : [],
      //Filtering
      niveaux,
      types,
      options: {
        sortBy  : "",
        sortDesc: true,
        filter  : {
          niveau: [],
          type  : [],
        },
      },
    }
  },
  methods: {
    filterFunction(row, filter) {
      return (filter.niveau.length ? filter.niveau.includes(row.niveau) : true) &&
          (filter.type.length ? filter.type.includes(row.type) : true);
    },
    onFiltered(filteredItems) {
      this.rows = filteredItems.length
      this.currentPage = 1
    },
    createExercice() {
      this.$router.push({name:"ExerciceEditor", params:{id:"new"}});
    },
    editExercice(id) {
      this.$router.push({name:"ExerciceEditor", params:{id}});
    },
  },
  created() {
    this.options = History.Persistence.Get() || this.options;
    Exercice.List().then(res => {
      this.items = res.reverse();
      this.isBusy = false;
    });
  },
}
</script>

<style scoped>

</style>